//"use client";

import React, { useEffect, useRef } from 'react';
import { resetHelpState, useHelpStateSnapshot } from 'store/storeValtio';
import parse from 'html-react-parser';
import { getHelpText } from './helpData';

export default function HelpModal() {
  const dialogRef = useRef(null);
  const hs = useHelpStateSnapshot();
  //console.log('HelpModal', hs);

  useEffect(() => {
    //console.log('HelpModal UE');
    if (hs.show) {
      dialogRef.current.showModal();

      const hd = document.querySelector("dialog");
      //console.log('hd', hd);
      hd.addEventListener("close", (event) => {
        console.log('HelpModal close event');
          resetHelpState();
        }
      );
    }
    return () => {
      //console.log('HelpModal return');
    //   resetHelpState();
    }
  }, [hs])

  function clicked() {
    //console.log('clicked');
    const hd = document.querySelector("dialog");
    hd.close();
  }
  const help = getHelpText(hs.forWhat);

  return (
    <dialog 
      onClick={()=>clicked()}
      className='w-[90vw] pb-4 px-4 border-2 rounded-md border-black' 
      ref={dialogRef}
      >
      <div className='flex justify-normal text-2xl font-semibold'>
        {parse(help.title)}
      </div>
      <div className='text-xl'>
        {parse(help.text)}
      </div>
    </dialog>
  )
}

 